// removed by extract-text-webpack-plugin
module.exports = {"container":"_3qYKTmWwZEEV9-7sjyTGnw","spin":"_3tpuaEIM1QIDak9Io4K1M5","dot":"_3yq7ogUQF-_0482jEz10He"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/styles.css
// module id = 310
// module chunks = 0